<template>
  <div>
    <div class="circle">?</div>
    <div v-if="description != ''" class="description">
      {{ description }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    description: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.circle {
  width: 12px;
  height: 12px;
  border-radius: 20px;
  box-sizing: border-box;
  font-family: "Arial Regular", "Arial", sans-serif;
  text-align: center;
  line-height: normal;
  font-size: 8px;
  border: 1px solid $color-primary;
  color: $color-primary;
  padding: 1px;
  cursor: pointer;
}
.description {
  margin-left: 5px;
}
</style>
